import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ProgProdSaleLineList } from '@/sc/entities/dirSaleLine/ProgProdSaleLineList';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';
import { useEffect, useLayoutEffect } from 'react';

export const InctvInvLineDetail = () => {
  const { entityObj, setEntityObj, entityDef } = useEntityMgr();
  const rsrc = useRsrc();

  // Stamp a clean placeholder before paint so the raw Entity code never flashes on screen
  useLayoutEffect(() => {
    if (entityObj.id && !entityObj.name) {
      setEntityObj({ ...entityObj, name: entityDef.displayName });
    }
  }, [entityObj, setEntityObj, entityDef]);

  // The line has no code of its own, so derive a readable title from its Program Product and Customer
  useEffect(() => {
    if (!entityObj.progProdId || !entityObj.payeeCustId) return;

    Promise.all([
      rsrc
        .byId('md', 'PROG_PROD', entityObj.progProdId)
        .then((progProdObj) => (progProdObj?.prodId ? rsrc.byId('md', 'PROD', progProdObj.prodId) : null)),
      rsrc.byId('md', 'CUST', entityObj.payeeCustId),
    ]).then(([prodObj, custObj]) => {
      if (!prodObj?.code || !custObj?.code) return;

      const computedName = prodObj.code + ' ' + custObj.code + ' Rebate Line';
      if (entityObj.name !== computedName) {
        setEntityObj({ ...entityObj, name: computedName });
      }
    });
  }, [entityObj, setEntityObj, rsrc]);

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm augFieldDefs={augInctvFieldDefs} /> },
    {
      id: 'saleLine',
      label: 'Sale Lines',
      content: (
        <ProgProdSaleLineList
          progProdId={entityObj.progProdId}
          custId={entityObj.custId}
          startDate={entityObj.rbtStartDate}
          endDate={entityObj.rbtEndDate}
        />
      ),
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
